import * as types from "./actionTypes";

export const get = () => {
  return {
    type: types.PROJECT_LIST_REQUEST
  };
};

export const getSuccess = data => {
  return {
    type: types.PROJECT_LIST_SUCCESS,
    payLoad: data
  };
};

export const getFailure = () => {
  return {
    type: types.PROJECT_LIST_FAILURE
  };
};

export const store = (data, isReload) => {
  return {
    type: types.PROJECT_STORE_REQUEST,
    data,
    isReload
  };
};
export const storeSuccess = data => {
  return {
    type: types.PROJECT_STORE_SUCCESS,
    payLoad: data
  };
};
export const storeFailure = () => {
  return {
    type: types.PROJECT_STORE_FAILURE
  };
};

export const deleteReq = id=>{
	return{
		type:types.PROJECT_DELETE_REQUEST,
		id
	}
};
export const deleteSuccess = (deletedProjectId) => {
  return {
    type: types.PROJECT_DELETE_SUCCESS,
    deletedProjectId
  };
};
export const deleteFailure = () => {
  return {
    type: types.PROJECT_DELETE_FAILURE,
  };
};

export const update = (data,id)=>{
	return{
		type:types.PROJECT_UPDATE_REQUEST,
		data,
		id
	}
};
export const editSuccess = data => {
  return {
    type: types.PROJECT_UPDATE_SUCCESS,
    payLoad: data
  };
};
export const editFailure = () => {
  return {
    type: types.PROJECT_UPDATE_FAILURE,
  };
};

export const accept = id => {
  return {
    type: types.PROJECT_ACCEPT_REQUEST,
    id
  };
};
export const acceptSuccess = data => {
  return {
    type: types.PROJECT_ACCEPT_SUCCESS,
    payLoad: data
  };
};
export const acceptFailure = data => {
  return {
    type: types.PROJECT_ACCEPT_FAILURE,
    payLoad: data
  };
};

export const reject = id => {
  return {
    type: types.PROJECT_REJECT_REQUEST,
    id
  };
};
export const rejectSuccess = data => {
  return {
    type: types.PROJECT_REJECT_SUCCESS,
    payLoad: data
  };
};
export const rejectFailure = data => {
  return {
    type: types.PROJECT_REJECT_FAILURE,
    payLoad: data
  };
};

export const archive = (id, data) =>{
  return{
    type:types.PROJECT_ARCHIVE_REQUEST,
    id,
    data
  }
};
export const archiveSuccess = (id, data) => {
  return {
    type: types.PROJECT_ARCHIVE_SUCCESS,
    id,
    data
  };
};
export const archiveFailure = () => {
  return {
    type: types.PROJECT_ARCHIVE_FAILURE,
  };
};

export const getUsersListRequest = () => {
  return {
    type: types.PROJECT_USERS_LIST_REQUEST,
  };
};
export const getUsersListSuccess = data => {
  return {
    type: types.PROJECT_USERS_LIST_SUCCESS,
    payLoad: data
  };
};
export const getUsersListFailure = data => {
  return {
    type: types.PROJECT_USERS_LIST_FAILURE
  };
};